import {FC, PropsWithChildren} from "react";
import {Container} from "react-bootstrap";
import MAppHeader from "./MAppHeader";
import MAppFooter from "./MAppFooter";

interface Props extends PropsWithChildren {};

const MAppMainLayout: FC<Props> = (props) => {
    return <Container fluid>
        <MAppHeader />
        <div style={{marginTop: "70px"}}></div>
        { props.children }
        <MAppFooter/>
    </Container>
}

export default MAppMainLayout;
